import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';

/**
 * Das ViewModel für Hidden
 */
export default class HiddenViewModel extends ControlViewModel {

    /**
     * Der Wert des Hidden
     */
    public value: KnockoutObservable<string>;

    /**
     * Das ViewModel für die Hidden
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);
        this.value = this.observableOrDefault(params.value, null);

        ControlViewModel.checkProperties(this, params);
    }
}

ComponentManager.setViewModel('HiddenViewModel', HiddenViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');